export const Routes = {
  root: '/',
  aboutus: '/aboutus',
  products: '/products',
  affiliated: '/affiliated',
  affiliatedDetail: '/affiliateddetail',
  paymentPoints: '/paymentpoints',
  LineaRevolventeyTarjetaPrivada: '/linearevolventeytarjetaprivada',
  tarjetadeCreditoMastercard: '/tarjetacreditomastercard',
  passwordRecovery: '/passwordRecovery',
  customerService: '/customerservice',        
  loyaltyProgram: '/loyaltyProgram',
  finiquitoVerification: '/verificacion-finiquito',
  claimProcess: '/claimprocess',
  payNotification: '/payNotification',
  creditCalculator: '/calculator',
  dashboard: '/account',
  CalculateInterest: '/calculateinterest',
  Contracts: '/contracts',
  financialeducation: '/financialEducation',
  downloadApp: '/downloadapp',
  Sales: '/sales',
  News: '/News',
  factoringDasboard: '/factoringDashboard',
  wizzardFactoring: '/WizzardFactoring',
  frecuentlyquestions: '/Faqs',
  resetPass: '/resetPass',
  termsAndConditions: '/TermsAndConditions',
  promotionHistory: '/PromotionHistory',
  factoring: '/factoring',
  factoringUser: '/factoringUser',
  inversiones: '/inversions',
  instantCash: '/instantCash',
  capacitacionLanding: '/capacitacion',
  capacitacionArticulo: '/capacitacion/:slug',
  factoringRequests: '/factoringRequests',
  factoringCreate: '/factoringCreate',
  costTablesHistory: '/cost-tables-history'
};

export default Routes;
